<template>
  <preview-zoom-dialog
    :dialogType="dialogType"
    :imageSrc="imageSrc"
    :dialogFile="dialogFile"
    :dialogFileMlUrl="dialogFileMlUrl"
    :name="imageName"
    @close-dialog="closePreviewZoomDialog"
  />
</template>

<script>
import PreviewZoomDialog from '@/components/dialogs/PreviewZoomDialog.vue'
import emitter from '@/mixins/emitter'
import axios from 'axios'

export default {
  name: 'GlobalPreviewMediaDialog',
  components: {
    PreviewZoomDialog,
  },
  mixins: [emitter],
  props: {},
  watch: {},
  data() {
    return {
      dialogType: 0,
      imageSrc: false,
      imageName: null,
      dialogFile: null,
      dialogFileMlUrl: null,
    }
  },
  created() {
    this.registerEvents()
  },
  computed: {},
  methods: {
    registerEvents() {
      this.$on('open-global-preview-media', media => {
        this.openPreviewZoomDialog(media)
      })
      this.$on('close-global-preview-media', () => {
        this.closePreviewZoomDialog()
      })
    },
    async openPreviewZoomDialog(media) {
      if (!media) return
      const {
        mediaUrl,
        imageName = null,
        mlResourceUrl = null,
        fileTypeId,
      } = media
      let newFileTypeId = fileTypeId
      let name = imageName || mediaUrl.replace(/^.*[\\/]/, '').split('?')[0]

      if (name.indexOf('.') <= 0 && mediaUrl && mediaUrl.startsWith('blob:')) {
        const fileData = await axios.get(mediaUrl, {
          responseType: 'arraybuffer',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
          },
        })
        const fileType = fileData?.headers?.['content-type']
        if (fileType.includes('image/')) {
          newFileTypeId = 18
          name += `${name}.${fileType.replace('image/', '')}`
        } else if (fileType.includes('video/')) {
          newFileTypeId = 19
          name += `${name}.${fileType.replace('video/', '')}`
        } else if (fileType.includes('pdf')) {
          newFileTypeId = 20
          name += `${name}.pdf`
        }
      } else if (!fileTypeId) {
        const extension = mediaUrl
          .split(/[#?]/)[0]
          .split('.')
          .pop()
          .trim()
          .toLowerCase()
        if (
          [
            'mp4',
            'avi',
            'mov',
            'm4a',
            '3gp',
            'webm',
            'mkv',
            'amr',
            'm4v',
          ].indexOf(extension) > -1
        ) {
          newFileTypeId = 19
        } else if (['jpg', 'png', 'jpeg', 'gif'].indexOf(extension) > -1) {
          newFileTypeId = 18
        } else if (['pdf'].indexOf(extension) > -1) {
          newFileTypeId = 20
        }
      }
      this.imageSrc = mediaUrl
      this.imageName = name
      this.dialogFile = mediaUrl
      this.dialogFileMlUrl = mlResourceUrl
      // fileTypeId 18 === 1 // photo
      // fileTypeId 19 === 3 // video
      // fileTypeId 20 === 5 // pdf
      this.dialogType = newFileTypeId === 20 ? 5 : newFileTypeId === 19 ? 3 : 1
    },
    closePreviewZoomDialog() {
      this.dialogType = 0
      this.currentFile = null
      this.imageSrc = null
      this.imageName = null
      this.dialogFileMlUrl = null
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
</style>
